import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, timeout: 45000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wu_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    const revoked = status === 403 && typeof detail === "string" && detail.toLowerCase().includes("revoked");
    if (status === 401 || revoked) {
      localStorage.removeItem("wu_token");
      localStorage.removeItem("wu_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export const fileUrl = (fileId) => {
  const token = localStorage.getItem("wu_token");
  return `${API}/files/${fileId}?auth=${encodeURIComponent(token || "")}`;
};

export const fmtMoney = (n) =>
  n == null || n === "" || isNaN(Number(n))
    ? "—"
    : `$${Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch (e) {
    return iso;
  }
};

// Local time (h:mm AM/PM) for an event.
// Calendly bookings store `time` in UTC, so we derive from `start_time_iso` when present.
// Manually-created events store `time` in the user's own local zone, so we return it as-is.
export const eventLocalTime = (ev) => {
  if (!ev) return "";
  if (ev.start_time_iso) {
    try {
      return new Date(ev.start_time_iso).toLocaleTimeString(undefined, {
        hour: "numeric", minute: "2-digit", hour12: true,
      });
    } catch (e) { /* fall through */ }
  }
  return ev.time || "";
};

// Local YYYY-MM-DD for an event (accounts for Calendly UTC → local roll-over).
export const eventLocalDate = (ev) => {
  if (!ev) return "";
  if (ev.start_time_iso) {
    try {
      const d = new Date(ev.start_time_iso);
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    } catch (e) { /* fall through */ }
  }
  return ev.date || "";
};

// Short US numeric date — used in CRM cards where space is tight.
// Accepts an ISO datetime or a YYYY-MM-DD string. Always renders as M/D/YYYY.
export const fmtDateUS = (val) => {
  if (!val) return "—";
  try {
    const s = String(val);
    // Pure YYYY-MM-DD → parse without timezone shift
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
      const [y, m, d] = s.split("-");
      return `${Number(m)}/${Number(d)}/${y}`;
    }
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return s;
    return d.toLocaleDateString("en-US", { month: "numeric", day: "numeric", year: "numeric" });
  } catch (e) {
    return String(val);
  }
};
